import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'btn2Hover',
  $names: {
    target: '[data-js-hover=btn2]',
  },
  styleInfo: {
    colorHovered: '#ceff00',
    colorDefault: '#0d0d0d',
    bgColorHovered: '#0d0d0d',
    bgColorDefault: '#ceff00',
  },
}

export default class Btn2Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      if ($target) {
        gsap.killTweensOf($target, ['backgroundColor', 'color'])
        gsap.to($target, {
          color: this.styleInfo.colorHovered,
          backgroundColor: this.styleInfo.bgColorHovered,
          duration: 0.4,
          ease: 'quart.out',
        })
      }

      gsap.delayedCall(0.4, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($target) {
        gsap.killTweensOf($target, ['backgroundColor', 'color'])
        gsap.to($target, {
          color: this.styleInfo.colorDefault,
          backgroundColor: this.styleInfo.bgColorDefault,
          duration: 0.4,
          delay: 0.05,
          ease: 'none',
        })
      }

      resolve()
    })
  }
}